const isDefined = (value: any): boolean =>
  Boolean(value !== undefined && value !== null);

export default isDefined;
